/**
 * @file   src\pages\Home.tsx
 * @brief  Home page.
 * @date   JUN, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */

import { React, useState, useEffect, useLocation, useSearchParams, Modal, Button, useNavigate, useParams, Link } from "../utils/thirdpartyComponents";
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import CWFooter from "src/components/CWFooter";
import WashSelection from "src/components/WashSelection";
import axios from '../config/axiosConfig';
import { SubscriptionandwashpriceApi, UserlocationApi } from "../utils/apiUrls";
import { MessageToaster } from "src/utils/toastUtil";
import { ISubscriptionandsinglewash, ISubscriptionarray, ISingleWasharray, ActiveSubscriptionarray } from '../interfaces/generalInterface';
import { BuyType,ServiceType, ServiceTypeLabel } from "src/utils/enums";
import { pageURLs } from "src/utils/pageUrls";
import CancelMySubscription from "src/components/CancelMySubscription";
import FullLoader from "src/components/FullLoader";
import SmallLoader from "src/components/SmallLoader";
import { CommonMessages } from 'src/messages/validationMessages';
import { getBayTypes, getFromLocalStorage } from "../utils/helper";
import { useGeolocated } from "react-geolocated";
import FullLoaderwithlocationfetch from '../components/FullLoaderwithlocationfetch';
import SelfServiceWashSelection from "src/components/SelfServiceWashSelection";
import Gobackicon from "../assets/images/left-arrow-small.svg";
import { IBayType } from "src/interfaces/bayinterface";


const SubscriptionAndWashprice = () => {
  // State to manage if there are no active subscriptions 
  const [inactive, setInactive] = useState(false);
  const {
        coords,
        isGeolocationAvailable,
        isGeolocationEnabled,
        getPosition,

      } =  useGeolocated({
        positionOptions: {
          enableHighAccuracy: true,
          maximumAge: 0,
          timeout: Infinity,
      },
      watchPosition: false,
      suppressLocationOnMount: false,
      geolocationProvider: navigator.geolocation,
      isOptimisticGeolocationEnabled: true,
      watchLocationPermissionChange: false,
  });
      

  const navigate = useNavigate()
  // Route information variable
  const params = useParams();

  // Initialise state for list of single wash
  const [showSingleWashTab, setshowSingleWashTab] = useState(true);

  const [loading, setLoading] = useState(false);
  const [listLoading, setListLoading] = useState(false);
  const [locationloading, setlocationLoading] = useState(false);

  const [showcancelConfirmation, setShowcancelConfirmation] = useState(false);

  // Initialise state for list of subscriptions
  const [subscriptions, setSubscriptions] = useState<ISubscriptionarray[]>([]);

  // Initialise state for list of single wash
  const [singleWash, setSingleWash] = useState<ISingleWasharray[]>([]);

  const location = useLocation();


  const queryParams = new URLSearchParams(location.search);
  const [tabactiveKey, setTabActiveKey] = useState(() => {
    // Set initial tab based on query parameter
    return queryParams.get('fromTab') === 'singlewash' ? 'singlewash' : 'subscriptions';
  });
  // const showSingleWash = queryParams.get('showSingleWash') === 'true';
  const showSingleWash = 'true';
  const hasQueryParams = location.search !== '';
  const scanAction = (queryParams.get('scan') === 'true') ? true : false;
  const bayselectAction = (queryParams.get('bayselect') === 'true') ? true : false;
  const washType = (queryParams.get('washType') === '1' || queryParams.get('washType') === '2') ? queryParams.get('washType') : 0;
  const bayTypeId = Number(queryParams.get('bayTypeId') ?? ServiceType.selfServe);
  const [searchParams, setSearchParams] = useSearchParams();
  const [showUpdateConfirmation, setShowUpdateConfirmation] = useState(false);
  const [activeSubscription, setActiveSubscription] = useState(0);
  const [selectedSubscription, setSelectedSubscription] = useState<ISubscriptionarray>();
  const [buyfromtab, setBuyfromtab] = useState('');
  const [updateConfirmationMessage, setupdateConfirmationMessage] = useState('Your subscription will switch to the new plan after your current plan expires. Are you sure you want to change your subscription now?');
  const [activeSubscriptionData, setActiveSubscriptionData] = useState<ActiveSubscriptionarray>();
  const [activeUserSubscriptionID,setActiveUserSubscriptionID] = useState(0);
  const [showTrailPeriodConsumptionModal, setTrailPeriodConsumptionModal] = useState(false);
  const [TrialSubscriptionAvailable, setTrialSubscriptionAvailable] = useState(false);
  const [activesinglewashid, setActivesinglewashid] = useState(0);
  const [cancelSubscriptionId,setCancelSubscriptionId] = useState(0);
  const [IsBackButton,setIsBackButton] = useState(false);
  const [activeBulkWash,setActiveBulkWash] = useState(false)


  useEffect(() => {
    if (location.state?.fromScanComplete) {
      setshowSingleWashTab(true);
      if(queryParams.get('nowashTime') === 'true')
      {
        setInactive(false);
      }
      else{
        setInactive(true);
      }
      
    }
    else if (queryParams.get('showSingleWash') === 'true' && queryParams.get('nowashTime') !== 'true') {
      setshowSingleWashTab(true);
      setInactive(true);
    }

    // Update the active tab if the query parameter changes
    const fromTab = searchParams.get('fromTab');
    if (fromTab === 'singlewash') {
      fetchSingleWashData();
      setTabActiveKey('singlewash');
    } else {
      setTabActiveKey('subscriptions');
    }

  }, [searchParams, location.state]);


  useEffect(() => {
    getPosition()

  }, [tabactiveKey]);

    useEffect(() => {
      if(searchParams.get('fromTab') === 'singlewash' && isGeolocationAvailable && isGeolocationEnabled && coords!== undefined && localStorage.getItem('locationPermissionGranted') !== 'true') {
        setlocationLoading(true);
        setTimeout(() => {
          setlocationLoading(false);
        }, 5000);
      }
    }, [coords, isGeolocationAvailable, isGeolocationEnabled,tabactiveKey]);

  const locationId_from_storage = localStorage.getItem('selectedLocation');
  const locationId = locationId_from_storage ? parseInt(locationId_from_storage, 10) : 0;

  const fetchSubscriptionData = async () => {
    // Instantiate MessageToaster
    const toaster = new MessageToaster();
    setListLoading(true)
    try {
      const requestSubscriptionData: ISubscriptionandsinglewash = {
        typeID: 2,
        locationId: locationId,
        bayType: bayTypeId
      };
      const responseSubscriptions = await axios.post(SubscriptionandwashpriceApi.Subscriptionandwashprice_FETCH, requestSubscriptionData);
      if (responseSubscriptions?.data?.error === 0) {
        setSubscriptions(responseSubscriptions?.data?.data?.subscriptionList);
        if (responseSubscriptions?.data?.data?.activeSubscription?.IsActive)
          
          setActiveSubscription(responseSubscriptions?.data?.data?.activeSubscription?.SubscriptionID);
          setActiveSubscriptionData(responseSubscriptions?.data?.data?.activeSubscription)
          setActiveUserSubscriptionID(responseSubscriptions?.data?.data?.activeSubscription?.UserSubscriptionID);
          //If already have purchased subscription we will not show trail period data
          const purchasedSubscription = (responseSubscriptions?.data?.data?.purchasedSubscription === 1) ? false : true;
          setTrialSubscriptionAvailable(purchasedSubscription)
          setActivesinglewashid(responseSubscriptions?.data?.data?.activeSingleWash);

           const activeBulkWash = responseSubscriptions?.data?.data?.activeBulkWash;
            if (activeBulkWash && Object.keys(activeBulkWash).length) {
            if(activeBulkWash?.WashTimeRemaining > 0)
            {
              setActiveBulkWash(true)
            }
          }

      }
      else {
        toaster.toastError(responseSubscriptions?.data?.message);
      }
      setListLoading(false)
    }
    catch (error) {
      throw new Error(error?.response?.data?.message || error?.message);
    }
  };

  useEffect(() => {
    localStorage.removeItem('subscriptionID')
    fetchSubscriptionData();
    getBayTypes().then((bayTypes: IBayType[]) => {
      if( bayTypes?.length > 1 && !hasQueryParams)
      {
        setIsBackButton(true)                            }
    })

  }, []);

  const fetchSingleWashData = async () => {
    const toaster = new MessageToaster();
    setListLoading(true)
    try {
      const requestSinglewashData: ISubscriptionandsinglewash = {
        typeID: 1,
        locationId: locationId,
        bayType: bayTypeId
      };
      const responseSingleWash = await axios.post(SubscriptionandwashpriceApi.Subscriptionandwashprice_FETCH, requestSinglewashData);

      if (responseSingleWash?.data?.error === 0) {
        setSingleWash(responseSingleWash?.data?.data?.subscriptionList);
      }
      else {
        toaster.toastError(responseSingleWash?.data?.message);
      }
      setListLoading(false)
    } catch (error: any) {
      throw new Error(error.response?.data?.message || error.message);
    }
  };

  //update confirmation modal close function
  const handleOnHide = () => { setShowUpdateConfirmation(false) }

  //buy now click function
  const buynowClick = async (subscription: ISubscriptionarray, buyfrom: string) => {
    setBuyfromtab(buyfrom);
    //if active subscription show confrmation modal
    if (activeSubscription && buyfrom === 'subscriptions') {
      if (activeSubscriptionData && activeSubscriptionData?.IsCancelled == 0 && activeSubscriptionData?.numberOfWashes === 0) {
        setupdateConfirmationMessage("Your active subscription has no wash remaining. Your subscription will switch to the new plan. Are you sure you want to change to the new subscription now?")
      } else if (activeSubscriptionData && activeSubscriptionData?.price < subscription.price) {
        setupdateConfirmationMessage("You are upgrading your subscription. Your subscription will switch to the new plan immediately. Are you sure you want to change to the new subscription now?")
      } else if (activeSubscriptionData && activeSubscriptionData?.price > subscription.price) {
        setupdateConfirmationMessage("You are going to downgrade your subscription. Your subscription will switch to the new plan after your current plan expires. Are you sure you want to change your subscription now?")
      }
      setSelectedSubscription(subscription)
      setShowUpdateConfirmation(true)
    }

    else {
      if (subscription.isTrial && TrialSubscriptionAvailable === true) {
        setLoading(true)
        const responseSubscriptions = await axios.get(SubscriptionandwashpriceApi.TRAIL_CONSUMPTION_CHECKING + '/' + subscription.subscriptionID);
        if (responseSubscriptions?.data?.error === 0 && responseSubscriptions?.data?.data?.isConsumed === 1) {
          setLoading(false)
          setSelectedSubscription(subscription)
          setTrailPeriodConsumptionModal(true)
        } else {
          setLoading(false)
          onBuy(subscription, buyfrom);
        }
      } else {
        onBuy(subscription, buyfrom);
      }

    }
  }

  //redirection to payment, or purchase immediately for manager free single wash
  const onBuy = async (subscription: ISubscriptionarray, buyfrom: string) => {
    const fromTab = buyfrom;
    const isManagerFreeSingleWash = subscription.subscriptionType === 1 && localStorage.getItem('freeSinglewash') === 'true';

    if (isManagerFreeSingleWash) {
      const toaster = new MessageToaster();
      try {
        setLoading(true);
        const param = {
          planId: subscription.subscriptionID,
          promo_code: '',
          locationId: Number(localStorage.getItem('selectedLocation')),
          promo_code_type: 1,
          payment_mode: 0,
          removeParentLink: false,
          buyupIds: []
        };
        const { data } = await axios.post(SubscriptionandwashpriceApi.PURCHASE_FREE_SINGLE_WASH, param);
        if (data?.error === 0) {
          localStorage.setItem('subscriptionID', String(subscription.subscriptionID));
          const selectedBay = localStorage.getItem('selectedBay') || location?.state?.bayId || '';
          if (selectedBay) {
            navigate("/" + params.carwashname + "/" + pageURLs.selfService, { state: { UserSubscriptionID: data?.data?.userSubscriptionId, bayId: selectedBay } });
          } else {
            toaster.toastSuccess(data?.message);
            navigate("/" + params.carwashname + "/" + pageURLs.home);
          }
        } else {
          toaster.toastError(data?.message);
        }
      } catch (error: any) {
        toaster.toastError(error?.response?.data?.message || error?.message);
      } finally {
        setLoading(false);
      }
      return;
    }

    if (showSingleWashTab == true && hasQueryParams) {
      navigate("/" + params.carwashname + "/" + pageURLs.payment + "?scan=" + scanAction + "&washType=" + washType, { state: { origin: 'WashSelection_withsingle_wash', fromTab: fromTab, subscriptionID: subscription.subscriptionID, washName: subscription.washName, price: subscription.price, numberOfWashes: subscription.numberOfWashes, subscriptionType: subscription.subscriptionType, bayId: location?.state?.bayId ? location?.state?.bayId : "", isTrial: subscription.isTrial, trialPeriod: subscription.trialPeriod, trialAmount: subscription.trialAmount, TrialSubscriptionAvailable : TrialSubscriptionAvailable,ServiceType: ServiceType.selfServe,FamilyDiscount:subscription.FamilyDiscount} })
    }
    else {
      navigate("/" + params.carwashname + "/" + pageURLs.payment + "?scan=" + scanAction + "&washType=" + washType, { state: { origin: 'WashSelection', fromTab: fromTab, subscriptionID: subscription.subscriptionID, washName: subscription.washName, price: subscription.price, numberOfWashes: subscription.numberOfWashes, subscriptionType: subscription.subscriptionType, isTrial: subscription.isTrial, trialPeriod: subscription.trialPeriod, trialAmount: subscription.trialAmount, TrialSubscriptionAvailable : TrialSubscriptionAvailable,baySubscriptionType:0 ,ServiceType: ServiceType.selfServe,FamilyDiscount:subscription.FamilyDiscount} })
    }
  };

  //confirm update subscription
  const ConfirmUpdate = async () => {
    if (selectedSubscription) {
      if (selectedSubscription.isTrial) {
        setShowUpdateConfirmation(false)
        setLoading(true)
        const responseSubscriptions = await axios.get(SubscriptionandwashpriceApi.TRAIL_CONSUMPTION_CHECKING + '/' + selectedSubscription.subscriptionID);
        if (responseSubscriptions?.data?.error === 0 && responseSubscriptions?.data?.data?.isConsumed === 1) {
          setLoading(false)
          setTrailPeriodConsumptionModal(true)
        } else {
          setLoading(false)
          onBuy(selectedSubscription, buyfromtab)
        }
      } else {
        onBuy(selectedSubscription, buyfromtab)
      }
    }

  }

  const ConfirmPurchase = () => {
    if (selectedSubscription) {
      selectedSubscription.isTrial = 0;
      selectedSubscription.trialAmount = 0;
      selectedSubscription.trialPeriod = 0;
      onBuy(selectedSubscription, buyfromtab)
    }
  }

  const cartPurchaseModalHide = () => {
    setSelectedSubscription([])
    setTrailPeriodConsumptionModal(false)
  }

  const cancelConfirmation = (cancelSubscriptionID) =>{
    setShowcancelConfirmation(true)
    setCancelSubscriptionId(cancelSubscriptionID)
  }
  const [insidelocationcheck, setInsidelocationcheck] = useState(false);
  //Check user location status
  const UserChecking = async() => {
    try {
      const geo_location  = getFromLocalStorage('geolocation')
      if(geo_location?.lat && geo_location?.long)
      {
        setLoading(true)
        const { data } = await axios.get(UserlocationApi.LOCATION_CHECK, {
          params: {
              lat: geo_location?.lat,
              lng: geo_location?.long
          }
        });
        setLoading(false)
        if(data.error === 0)
        {
          let hostname = window.location.origin
          if((localStorage.getItem('selectedLocation')=='249' && hostname == 'https://staging-web.carwashapp.com') || localStorage.getItem('freeSinglewash')=='true')
          {
            setInsidelocationcheck(true)
          }
          else{
          setInsidelocationcheck(data.data);
          }
        } else {
          console.log(data.message);
        } 
        
      } else{
        localStorage.removeItem('locationPermissionDenied');
        console.log(CommonMessages.no_loc_permission);
      }
      
    }  catch (error) {
        console.log(error);
      }
    }

    useEffect(() => {
      if(tabactiveKey === 'singlewash') {
        UserChecking();  
      }      
    }, [tabactiveKey]);
  


  return (
    <div className="common-content-wrap pb-80">
      <div className={inactive ? "inner-content-wrap no-subscription-added" : "inner-content-wrap"}>
        <div className="common-header two-block-header">
          <div className="pe-4 ps-4 pt-0 pb-0 h-100">
            <div className="common-header-inner align-items-center">
              {IsBackButton?
                <div className="common-header-inner">
                    <Link to={"/"+params.carwashname+"/"+pageURLs.selectBayType} className="back-link"><img src={Gobackicon} alt="Car Wash App" /></Link>Buy a {bayTypeId===ServiceType.vacuumWash ? "Vacuum":`Wash-${ServiceTypeLabel[bayTypeId as ServiceType]}`}
                  </div>:
                  <div className="info">
                    <h4 className="pb-0">Buy a {bayTypeId===ServiceType.vacuumWash ? "Vacuum":`Wash-${ServiceTypeLabel[bayTypeId as ServiceType]}`}</h4>
                  </div>}
            </div>
          </div>
        </div>

        {/** This div shown only if there are no active subscriptions.*/}
        <div className={inactive ? "subscription-alert d-block" : "subscription-alert"}>
          <div className="subscription-alert-inner">
            <svg xmlns="http://www.w3.org/2000/svg" width="20.197" height="25.538" viewBox="0 0 20.197 25.538"><g transform="translate(-36.803 -95)"><path d="M.234-.625H10.482a.86.86,0,0,1,.859.859V18.679a.86.86,0,0,1-.859.859H.234a.86.86,0,0,1-.859-.859V.234A.86.86,0,0,1,.234-.625ZM10.091.625H.625V18.288h9.466Z" transform="translate(37.428 101)" fill="#fff" /><path d="M13.641,2.55a2.735,2.735,0,1,1-2.734,2.735A2.738,2.738,0,0,1,13.641,2.55Zm0,4.469a1.735,1.735,0,1,0-1.734-1.735A1.736,1.736,0,0,0,13.641,7.019Z" transform="translate(29.169 100.229)" fill="#fff" /><path d="M5.563.5H0v-1H5.563Z" transform="translate(40.056 110.472)" fill="#fff" /><path d="M3.179.5H0v-1H3.179Z" transform="translate(41.241 112.946)" fill="#fff" /><path d="M15.689,18.295H11.551a1.5,1.5,0,1,1,0-3h4.138a1.5,1.5,0,0,1,0,3Zm-4.138-2a.5.5,0,0,0,0,1h4.138a.5.5,0,0,0,0-1Z" transform="translate(29.221 99.46)" fill="#fff" /><circle cx="8" cy="8" r="8" transform="translate(41 95)" fill="#ffd500" /><path d="M8,2a6,6,0,1,0,6,6A6.007,6.007,0,0,0,8,2M8,0A8,8,0,1,1,0,8,8,8,0,0,1,8,0Z" transform="translate(41 95)" fill="#0165bc" /><g transform="translate(47 101)"><line x1="5.657" transform="translate(0 0) rotate(45)" fill="none" stroke="#000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.2" /><line x1="5.657" transform="translate(0 4) rotate(-45)" fill="none" stroke="#000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.2" /></g></g></svg>
            <p>You don't have an active subscription.</p>
          </div>
        </div>

        <Tabs
          activeKey={tabactiveKey}
          onSelect={(k) => {
            // Ensure k is a string before setting it as active key
            if (typeof k === 'string') {
              setTabActiveKey(k);
              // Update query parameter based on tab selection
              const searchParams = new URLSearchParams(location.search);
              if (k === 'singlewash') {
                searchParams.set('fromTab', 'singlewash');
              } else {
                searchParams.set('fromTab', 'subscriptions');
              }
              // Update the URL with the new query parameters
              navigate({
                pathname: location.pathname,
                search: searchParams.toString(),
              });
            }
          }}
          id="uncontrolled-tab-example"
          className="buy-wash-tabwrap"
        >
  <Tab eventKey="subscriptions" title="Subscriptions">
  {listLoading ? (
    <FullLoader />
  ) : (
    <>
      {subscriptions?.length ? (
        subscriptions.map((subscription) => {
          const commonProps = {
            // key: index,
            SubscriptionID: subscription.subscriptionID,
            WashName: subscription.washName,
            SubscriptionDetails: subscription.subscriptionDetails,
            Price: subscription.price,
            NumberOfWashes: subscription.numberOfWashes,
            dailyWashLimit: subscription.dailyWashLimit,
            show_single_wash: showSingleWashTab,
            buyType: BuyType.SUBSCRIPTION,
            hasActiveSubscription: activeSubscription,
            setShowUpdateConfirmation,
            subscription,
            onBuynowClick: (subscription: ISubscriptionarray) =>
              buynowClick(subscription, 'subscriptions'),
            cancelConfirmation: (id: number) =>
              cancelConfirmation(id),
            subscriptionType: subscription.subscriptionType,
            TrialSubscriptionAvailable,
            coords,
            isGeolocationAvailable,
            isGeolocationEnabled,
            WashTime:subscription.WashTime,
            activeUserSubscriptionID:activeUserSubscriptionID,
             HasVacuumWash:subscription.HasVacuumWash,
            NumberOfVacuumWashes:subscription.NumberOfVacuumWashes,
            MaxVacuumTime:subscription.MaxVacuumTime,
            FamilyDiscount:subscription.FamilyDiscount

          };
          return <SelfServiceWashSelection key={ subscription.subscriptionID} {...commonProps} />
          // return bayTypeId === 0
          //   // ? <WashSelection key={ subscription.subscriptionID} {...commonProps} />
          //   : <SelfServiceWashSelection key={ subscription.subscriptionID} {...commonProps} />;
        })
      ) : (
        <tr>
          <p>No data found</p>
        </tr>
      )}
    </>
  )}
</Tab>

         {showSingleWash && (
  <Tab eventKey="singlewash" title={bayTypeId== ServiceType.vacuumWash ? "Single Use":"Single Wash"} onEnter={fetchSingleWashData}>
    {listLoading ? (
      <FullLoader />
    ) : (
      <>
        {singleWash && singleWash.length > 0 ? (
          singleWash.map((wash) => {
            const commonProps = {
              // key: index,
              SubscriptionID: wash.subscriptionID,
              WashName: wash.washName,
              SubscriptionDetails: wash.subscriptionDetails,
              Price: wash.price,
              show_single_wash: showSingleWashTab,
              buyType: BuyType.SINGLE_WASH,
              subscription: wash,
              onBuynowClick: (subscription: ISubscriptionarray) => buynowClick(subscription, 'singlewash'),
              setShowcancelConfirmation: (flag: boolean) => setShowcancelConfirmation(flag),
              subscriptionType: wash.subscriptionType,
              WashTime:wash.WashTime,
              PriceForExtraTime:wash.PriceForExtraTime,
              scanAction,
              bayselectAction,
              insidelocationcheck,
              activesinglewashid,
              coords,
              isGeolocationAvailable,
              isGeolocationEnabled,
              HasVacuumWash:wash.HasVacuumWash,
              NumberOfVacuumWashes:wash.NumberOfVacuumWashes,
              MaxVacuumTime:wash.MaxVacuumTime,
              NumberOfWashes: wash.numberOfWashes,
              ActiveBulkWash:activeBulkWash,
              CanExtentSingleWash: wash.CanExtentSingleWash


              // PriceForExtraTime:wash.PriceForExtraTime

            };

            return <SelfServiceWashSelection key={ wash.subscriptionID} {...commonProps} />;
          })
        ) : (
          <tr>
            <p>No data found</p>
          </tr>
        )}
      </>
    )}
  </Tab>
)}

        </Tabs>
      </div>
      <CWFooter activeLink={hasQueryParams ? "Home" : "Subscriptions"} />
      {/* signout confirmation Modal */}
      <Modal
        show={showUpdateConfirmation}
        onHide={handleOnHide}
        centered
        className='notification-modal'
      >
        {/* Update subscription confirmation modal */}
        <Modal.Body className='text-center'>
          <h6>{updateConfirmationMessage}
          </h6>
        </Modal.Body>
        <Modal.Footer className='d-grid'>
          <Button variant="light" className="m-0" onClick={handleOnHide}>No</Button>
          <Button variant="primary" className='primary-btn btn-main m-0' onClick={ConfirmUpdate}>Yes</Button>
        </Modal.Footer>
      </Modal>


      <Modal
        show={showTrailPeriodConsumptionModal}
        onHide={cartPurchaseModalHide}
        centered
        className='notification-modal'
      >
        <Modal.Body className='text-center'>
          <h6>You have already used the trial period, so the normal rates will apply. Do you want to continue?</h6>
        </Modal.Body>
        <Modal.Footer className='d-grid'>
          <Button variant="light" className="m-0" onClick={cartPurchaseModalHide}>Cancel</Button>
          <Button variant="primary" className='primary-btn btn-main m-0' onClick={ConfirmPurchase}>Continue</Button>
        </Modal.Footer>
      </Modal>
      <CancelMySubscription
        setShowcancelConfirmation={(flag: boolean) => setShowcancelConfirmation(flag)}
        setLoading={(flag: boolean) => setLoading(flag)}
        showcancelConfirmation={showcancelConfirmation}
        from={'purchase'}
        cancelSubscriptionID={cancelSubscriptionId}
      // from={pageURLs.subscriptionandwashprice}
      />
      {loading ? <FullLoader /> : ""}
      {locationloading && <FullLoaderwithlocationfetch />}
    </div>
  )
};

export default SubscriptionAndWashprice;
